import gsap from 'gsap';
import grid, { calculateGap, calculateMargin, calculateWidth, pxToVw } from './grid';

class GridDebug {
	constructor() {
		this.isVisible = false;
		this.dom = {};
		this.createDom();
		this.bindEvents();
	}

	createDom() {
		const root = document.createElement('div');
		root.className = 'gridDebug';
		root.setAttribute('aria-hidden', 'true');

		root.appendChild(this.createLayer('gridDebug__layer--mobile', grid.mobile));
		root.appendChild(this.createLayer('gridDebug__layer--tablet', grid.tablet));
		root.appendChild(this.createLayer('gridDebug__layer--desktop', grid.desktop));

		document.body.appendChild(root);
		this.dom.root = root;
	}

	createLayer(modifier, config) {
		const layer = document.createElement('div');
		const gap = calculateGap(config.gutter, config.mockupWidth);
		const margin = calculateMargin(config.margin, config.mockupWidth);
		const colWidth = pxToVw(
			calculateWidth(config.columns, config.gutter, config.margin, config.mockupWidth, 1),
			config.mockupWidth
		);

		layer.className = `gridDebug__layer ${modifier}`;
		layer.style.gap = gap;
		layer.style.columnGap = gap;
		layer.style.paddingLeft = margin;
		layer.style.paddingRight = margin;

		for (let i = 0; i < config.columns; i++) {
			const col = document.createElement('div');
			col.className = 'gridDebug__col';
			col.style.width = colWidth;
			col.style.flexShrink = '0';
			col.dataset.grid = '';
			layer.appendChild(col);
		}

		return layer;
	}

	bindEvents() {
		window.addEventListener('keydown', (e) => {
			if (e.key.toLowerCase() !== 'g') return;
			if (e.target.matches('input, textarea, select, [contenteditable="true"]')) return;
			this.toggle();
		});
	}

	toggle() {
		this.isVisible = !this.isVisible;
		this.dom.root.classList.toggle('is-visible', this.isVisible);
		this.dom.root.setAttribute('aria-hidden', String(!this.isVisible));

		const cols = this.dom.root.querySelectorAll('[data-grid]');
		gsap.to(cols, {
			duration: 0.5,
			y: this.isVisible ? 0 : '-100%',
			stagger: 0.02,
			ease: 'power3.out',
		});
	}
}

export default GridDebug;
